import { useState, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import { Row, Col } from "reactstrap";
import { CFormLabel, CFormInput } from "@coreui/react";
import Select from "react-select";
import APLDataGrid from "../DataGrids/APLDataGrid";
import { FormattedMessage, useIntl } from "react-intl";

const APLCreateNewWorkCard = (props) => {
  const intl = useIntl();
  const [selectableWorkCards, setSelectableWorkCards] = useState([]);

  useEffect(() => {
    let tempSelectableWorkCards = [];
    props.existingWorkCards.forEach((wc) => {
      let selectableWorkCard = {
        value: wc,
        label: wc.name,
      };
      tempSelectableWorkCards.push(selectableWorkCard);
      setSelectableWorkCards(tempSelectableWorkCards);
    });
  }, [props.existingWorkCards]);

  let columnExtensions = [
    { columnName: "name", width: 350 },
    { columnName: "edit", width: 100, padding: 0 },
  ];

  const columns = [
    { title: <FormattedMessage id="Name" />, name: "name" },
    { title: <FormattedMessage id="Edit" />, name: "edit" },
  ];

  return (
    <Card style={{ marginTop: "0.1rem" }}>
      <CardBody style={{ padding: ".5rem", border: "none" }}>
        <Row>
          <Col>
            <CFormLabel htmlFor="workCardName">
              <FormattedMessage id="NameOfWorkCard" />:
            </CFormLabel>
            <CFormInput
              type="text"
              id="workCardName"
              name="workCardName"
              onChange={(data) => props.setNewWorkcardName(data.target.value)}
              placeholder="Namn..."
              autoComplete="false"
            />

            {props.aplValidationErrors.includes("aplCreateWorkcardNoName") && (
              <p className="text-danger">
                <FormattedMessage id="NameRequired" />
              </p>
            )}
            {props.aplWorkcardNameAlreadyExists && (
              <p className="text-danger">
                <FormattedMessage id="NameAlreadyUsedForWorkcard" />
              </p>
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <CFormLabel htmlFor="workCardBluePrint">
              <FormattedMessage id="WorkCardAsTemplate" />:
            </CFormLabel>
            <Select
              menuPosition={"fixed"}
              name="workCardBluePrint"
              options={selectableWorkCards.map((option) => ({
                label: option.label,
                value: option,
              }))}
              placeholder={intl.formatMessage({ id: "ChooseWorkCard" })}
              onChange={(selected) =>
                props.handleSelectWorkCardTemplate(selected.value)
              }
            />
          </Col>
        </Row>
        <APLDataGrid
          data={props.tableData}
          columns={columns}
          columnExtensions={columnExtensions}
        />
      </CardBody>
    </Card>
  );
};
export default APLCreateNewWorkCard;
